import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear(); // Gets the current year automatically

  return (
    <footer className="site-footer">
      <p>© {currentYear} Sax and the City. All rights reserved.</p>
    </footer>
  );
}

export default Footer;